import { useQuery } from '@tanstack/react-query';
import { uiPreferenceRequests } from '@/lib/api/requests/ui-preferences';
import { uiPreferenceKeys } from './keys';

export function useUiPreferences(enabled = true) {
  return useQuery({
    queryKey: uiPreferenceKeys.all,
    queryFn: () => uiPreferenceRequests.get(),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
